import React from 'react';
import { Grid, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem, FormHelperText, Button } from '@mui/material';
import { doctorGroups } from '../constants/options';

const BeforeSkinIncision = ({ formData, setFormData, errors, setErrors, handleChange, handleCheckboxChange, handleBlur, handleSignatureOpen }) => {
  const handleNameChange = (e) => {
    const regex = /^[a-zA-Z\s.-]*$/;
    const { name, value } = e.target;
    if (value === '' || regex.test(value)) {
      setFormData(prev => ({ ...prev, [name]: value }));
      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: '' }));
      }
    }
  };

  return (
    <>
      <FormControlLabel 
        control={<Checkbox checked={formData.team_introduction} onChange={handleChange} name="team_introduction" />} 
        label="Confirm all team members have introduced themselves by name & role" 
      />
      
      <hr className="my-3" />

      <div className="font-semibold mb-2">Surgeon, Anesthesia professional and nurse verbally confirm:</div>
      <FormControlLabel control={<Checkbox checked={formData.patient_confirmation} onChange={handleChange} name="patient_confirmation" />} label="Patient" />
      <FormControlLabel control={<Checkbox checked={formData.site_confirmation} onChange={handleChange} name="site_confirmation" />} label="Site" />
      <FormControlLabel control={<Checkbox checked={formData.procedure_confirmation} onChange={handleChange} name="procedure_confirmation" />} label="Procedure" />
      
      <hr className="my-3" />
      
      <div className="font-semibold mb-2">Anticipated critical event:</div>
      <FormControlLabel 
        control={<Checkbox checked={formData.anticipated_critical_event} onChange={handleChange} name="anticipated_critical_event" />} 
        label="Surgeon View: What are the critical or unexpected steps, operative duration, anticipated blood loss?" 
      />
      <FormControlLabel 
        control={<Checkbox checked={formData.anesthesia_team_review} onChange={handleChange} name="anesthesia_team_review" />} 
        label="Anesthesia Team Reviews: What are the critical or unexpected steps, operative duration, anticipated blood loss?" 
      />
      <FormControlLabel 
        control={<Checkbox checked={formData.nursing_team_review} onChange={handleChange} name="nursing_team_review" />} 
        label="Nursing Team Reviews: Has sterility (including indicator results) been confirmed? Are there equipment issues or any concerns?" 
      />

      <hr className="my-3" />
      
      <div className="font-semibold mb-1">Has antibiotic prophylaxis been given within the last 60 minutes?</div>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.antibiotic_prophylaxis === "yes"}
            onChange={(event) => handleCheckboxChange(event, "yes", "antibiotic_prophylaxis")}
            name="antibiotic_prophylaxis_yes"
          />
        }
        label="Yes"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.antibiotic_prophylaxis === "no"}
            onChange={(event) => handleCheckboxChange(event, "no", "antibiotic_prophylaxis")}
            name="antibiotic_prophylaxis_no"
          />
        }
        label="NA"
      />

      <div className="font-semibold mt-2 mb-1">Is essential imaging displayed?</div>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.essential_imaging_displayed === "yes"}
            onChange={(event) => handleCheckboxChange(event, "yes", "essential_imaging_displayed")}
            name="essential_imaging_displayed_yes"
          />
        }
        label="Yes"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.essential_imaging_displayed === "no"}
            onChange={(event) => handleCheckboxChange(event, "no", "essential_imaging_displayed")}
            name="essential_imaging_displayed_no"
          />
        }
        label="NA"
      />

      <hr className="my-3" />
      <div className="font-bold text-center mt-4">ANESTHESIOLOGIST</div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth sx={{ marginTop: 1 }}>
            <InputLabel id="anesthesiologist_name-label">Name (Anesthesiologist)</InputLabel>
            <Select
              labelId="anesthesiologist_name-label"
              name="anesthesiologist_name"
              value={formData.anesthesiologist_name || ""}
              onChange={handleNameChange}
              onBlur={handleBlur}
              error={!!errors.anesthesiologist_name}
              label="Name (Anesthesiologist)"
            >
              <MenuItem value="">
                <em>Select Doctor</em>
              </MenuItem>
              {(doctorGroups["AnaesthesiaSpecialists"] || []).map((doctor, idx) => (
                <MenuItem key={idx} value={doctor}>
                  {doctor}
                </MenuItem>
              ))}
            </Select>
            {errors.anesthesiologist_name && <FormHelperText>{errors.anesthesiologist_name}</FormHelperText>}
          </FormControl>

          <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen("anesthesiologist_signature")}> 
            Sign Here 
          </Button>
          {formData.anesthesiologist_signature && (
            <img 
              src={`data:image/png;base64,${formData.anesthesiologist_signature}`} 
              alt="Signature" 
              style={{ marginTop: 10, border: '1px solid black', width: '100%', height: '150px', objectFit: 'contain' }} 
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default BeforeSkinIncision;
